import { useAppTheme, useIntl } from '@capsicum/common';
import { type SVGProps, useMemo } from 'react';
import { styled } from 'styled-components';
import { match } from 'ts-pattern';

import { FanxBlackIcon, FanxWhiteIcon, KayenIcon } from '../../../ui/icons';
import { Text } from '../../atoms';

export type PoweredByProps = {
	type?: 'fanx' | 'kayen';
};

type ContentShape = {
	Icon: React.ComponentType<SVGProps<SVGSVGElement>>;
	text: string;
} | null;

export const PoweredBy = ({ type = 'kayen', ...props }: PoweredByProps) => {
	const { $t } = useIntl();
	const { mode } = useAppTheme();

	const content: ContentShape = useMemo(() => {
		return match(type)
			.with('kayen', () => ({
				Icon: KayenIcon,
				text: $t('payments.lobby.poweredByKayenSwap')
			}))
			.with('fanx', () => ({
				Icon: mode === 'light' ? FanxBlackIcon : FanxWhiteIcon,
				text: $t('payments.lobby.poweredByFanxSwap')
			}))
			.otherwise(() => null);
	}, [type, $t, mode]);

	if (!content) return null;

	const { Icon, text } = content;

	return (
		<S.Wrapper {...props}>
			<S.Label variant="text5">{text}</S.Label>
			{Icon && <Icon />}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: row;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		align-items: center;
	`;
	export const Label = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.subtle};
	`;
}
